module.exports = __webpack_public_path__ + "static/media/Bot3.443ebbca.jpeg";